import {} from "../value/index.js";
export function checkAllLocalsAreUsed(locals) {
    if (locals.size > 0) {
        throw new Error([
            `[checkAllLocalsAreUsed] I expect all locals are used.`,
            ``,
            `  unused local names: ${Array.from(locals.keys()).join(", ")}`,
        ].join("\n"));
    }
}
//# sourceMappingURL=checkAllLocalsAreUsed.js.map